/* eslint-disable import/no-cycle */
import Register from '../views/register/Register.vue';
import Parent from '../views/Parent.vue';

// import inputer aggregator
import InputerAggregator from '../views/inputer/aggregator/Aggregator.vue';
import InputerAggregatorDetail from '../views/inputer/aggregator/AggregatorDetail.vue';
import InputerAggregatorUpload from '../views/inputer/aggregator/AggregatorUpload.vue';
import InputerAddAggregator from '../views/inputer/aggregator/AddAggregator.vue';
import InputerAggregatorUpdate from '../views/inputer/aggregator/AggregatorUpdate.vue';
import InputerSubMerchant from '../views/inputer/aggregator/SubMerchant.vue';
import InputerSubMerchantOutlet from '../views/inputer/aggregator/SubMerchantOutlet.vue';

// import inputer merchant
import InputerMerchant from '../views/inputer/merchant/Merchant.vue';
import InputerMerchantDetail from '../views/inputer/merchant/MerchantDetail.vue';
import InputerMerchantUpload from '../views/inputer/merchant/MerchantUpload.vue';
import InputerMerchantUpdate from '../views/inputer/merchant/MerchantUpdate.vue';
import InputerMerchantOutlet from '../views/inputer/merchant/MerchantOutlet.vue';

import { setBreadcrumb } from './index';

const inputerRoute = {
  path: '/inputer',
  name: 'Inputer',
  meta: {
    title: 'BNI QRIS - Inputer',
    appBarTitle: 'Inputer',
  },
  component: Parent,
  children: [
    {
      path: '/inputer/merchant',
      meta: {
        title: 'BNI QRIS - Merchant',
        appBarTitle: 'Merchant',
        breadcrumbs: () => [
          setBreadcrumb('inputer', '/inputer', true),
          setBreadcrumb('merchant', '/inputer/merchant'),
        ],
      },
      component: InputerMerchant,
      name: 'InputerMerchant',
    },
    {
      path: '/inputer/merchant/:view/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Merchant Detail',
        appBarTitle: 'Merchant Detail',
        breadcrumbs: (params) => {
          const { view } = params;
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('merchant', '/inputer/merchant'),
            setBreadcrumb(`${view}`, `/inputer/merchant/${view}`, true),
            setBreadcrumb(`${id}`, `/inputer/merchant/${view}/${id}`),
          ];
        },
      },
      component: InputerMerchantDetail,
      name: 'InputerMerchantDetail',
    },
    {
      path: '/inputer/merchant/:id/bulk-upload',
      meta: {
        title: 'BNI QRIS - Bulk Upload Merchant',
        appBarTitle: 'Bulk Upload Merchant',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('merchant', '/inputer/merchant'),
            setBreadcrumb(
              `${id.replaceAll('-', ' ')}`,
              `/inputer/merchant/${id}`,
              true
            ),
            setBreadcrumb('bulk upload', `/inputer/merchant/${id}/bulk-upload`),
          ];
        },
      },
      component: InputerMerchantUpload,
      name: 'InputerBulkUploadMerchant',
    },
    {
      path: '/inputer/aggregator',
      meta: {
        title: 'BNI QRIS - Aggregator',
        appBarTitle: 'Aggregator',
        breadcrumbs: () => [
          setBreadcrumb('inputer', '/aggregator', true),
          setBreadcrumb('aggregator', '/inputer/aggregator'),
        ],
      },
      component: InputerAggregator,
      name: 'InputerAggregator',
    },
    {
      path: '/inputer/sub-merchant',
      meta: {
        title: 'BNI QRIS - Sub Merchant',
        appBarTitle: 'Inputer Sub Merchant',
        breadcrumbs: () => [
          setBreadcrumb('inputer', '/inputer', true),
          setBreadcrumb('sub merchant', '/inputer/sub-merchant'),
        ],
      },
      component: InputerSubMerchant,
      name: 'InputerAllSubMerchant',
    },
    {
      path: '/inputer/sub-merchant/:id(\\d+)/list-outlet',
      name: 'InputerAllSubMerchantOutlet',
      meta: {
        title: 'BNI QRIS - Sub Merchant Outlet',
        appBarTitle: 'Sub Merchant Outlet',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('sub merchant', '/inputer/sub-merchant'),
            setBreadcrumb(`${id}`, `/inputer/sub-merchant/${id}`, true),
            setBreadcrumb(
              'list outlet',
              `/inputer/sub-merchant/${id}/list-outlet`,
              true
            ),
          ];
        },
      },
      component: InputerSubMerchantOutlet,
    },
    {
      path: '/client/merchant/register/',
      name: 'InputerRegisterMerchant',
      meta: {
        title: 'BNI QRIS - Register Merchant',
        appBarTitle: 'Register Merchant',
      },
      component: Register,
    },
    {
      path: '/client/merchant/register/:id(\\d+)',
      name: 'InputerRegisterOutlet',
      meta: {
        title: 'BNI QRIS - Register Outlet',
        appBarTitle: 'Register Outlet',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('merchant', '/inputer/merchant'),
            setBreadcrumb('register outlet', '/client/merchant/register', true),
            setBreadcrumb(`${id}`, `/client/merchant/register/${id}`),
          ];
        },
      },
      component: Register,
    },
    {
      path: '/inputer/aggregator/view/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Aggregator Detail',
        appBarTitle: 'Aggregator Detail',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb('view', '/inputer/aggregator/view', true),
            setBreadcrumb(`${id}`, `/inputer/aggregator/view/${id}`),
          ];
        },
      },
      component: InputerAggregatorDetail,
      name: 'InputerAggregatorDetail',
    },
    {
      path: '/inputer/aggregator/:id/bulk-upload',
      meta: {
        title: 'BNI QRIS - Bulk Upload Aggregator',
        appBarTitle: 'Bulk Upload Aggregator',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb(
              `${id.replaceAll('-', ' ')}`,
              `/inputer/aggregator/${id}`,
              true
            ),
            setBreadcrumb(
              'bulk upload',
              `/inputer/aggregator/${id}/bulk-upload`
            ),
          ];
        },
      },
      component: InputerAggregatorUpload,
      name: 'InputerBulkUploadAggregator',
    },
    {
      path: '/inputer/aggregator/register',
      name: 'InputerRegisterAggregator',
      meta: {
        title: 'BNI QRIS - Register Aggregator',
        appBarTitle: 'Register Aggregator',
        breadcrumbs: () => [
          setBreadcrumb('inputer', '/inputer', true),
          setBreadcrumb('aggregator', '/inputer/aggregator'),
          setBreadcrumb('register', '/client/merchant/register', true),
        ],
      },
      component: InputerAddAggregator,
    },
    {
      path: '/inputer/aggregator/update/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Aggregator Update',
        appBarTitle: 'Aggregator Update',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb('update', '/inputer/aggregator/update', true),
            setBreadcrumb(`${id}`, `/inputer/aggregator/update/${id}`, true),
          ];
        },
      },
      component: InputerAggregatorUpdate,
      name: 'InputerAggregatorUpdate',
    },
    {
      path: '/inputer/merchant/update/:id(\\d+)/:pten',
      meta: {
        title: 'BNI QRIS - Merchant Update',
        appBarTitle: 'Merchant Update',
        breadcrumbs: (params) => {
          const { id } = params;
          const { pten } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('merchant', '/inputer/merchant'),
            setBreadcrumb('update', '/inputer/merchant/update', true),
            setBreadcrumb(`${id}`, `/inputer/merchant/update/${id}`, true),
            setBreadcrumb(
              `${pten}`,
              `/inputer/merchant/update/${id}/${pten}`,
              true
            ),
          ];
        },
      },
      component: InputerMerchantUpdate,
      name: 'InputerMerchantUpdate',
    },
    {
      path: '/inputer/aggregator/:id(\\d+)/sub-merchant',
      name: 'InputerSubMerchant',
      meta: {
        title: 'BNI QRIS - Sub Merchant',
        appBarTitle: 'Sub Merchant',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb(`${id}`, `/inputer/aggregator/${id}`, true),
            setBreadcrumb(
              'sub merchant',
              `/inputer/aggregator/${id}/sub-merchant`,
              true
            ),
          ];
        },
      },
      component: InputerSubMerchant,
    },
    {
      path: '/inputer/aggregator/:idAggregator(\\d+)/register',
      name: 'InputerSubMerchantRegister',
      meta: {
        title: 'BNI QRIS - Sub Merchant',
        appBarTitle: 'Sub Merchant',
        breadcrumbs: (params) => {
          const { idAggregator } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb(
              `${idAggregator}`,
              `/inputer/aggregator/${idAggregator}`,
              true
            ),
            setBreadcrumb(
              'register',
              `/inputer/aggregator/${idAggregator}/register`,
              true
            ),
          ];
        },
      },
      component: Register,
    },
    {
      path: '/inputer/aggregator/:idAggregator(\\d+)/sub-merchant/:id(\\d+)/list-outlet',
      name: 'InputerSubMerchantOutlet',
      meta: {
        title: 'BNI QRIS - Sub Merchant Outlet',
        appBarTitle: 'Sub Merchant Outlet',
        breadcrumbs: (params) => {
          const { id } = params;
          const { idAggregator } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb(
              `${idAggregator}`,
              `/inputer/aggregator/${idAggregator}`,
              true
            ),
            setBreadcrumb(
              'sub merchant',
              `/inputer/aggregator/${idAggregator}/sub-merchant`
            ),
            setBreadcrumb(
              `${id}`,
              `/inputer/aggregator/${idAggregator}/sub-merchant/${id}`,
              true
            ),
            setBreadcrumb(
              'list outlet',
              `/inputer/aggregator/${idAggregator}/sub-merchant/${id}/list-outlet`,
              true
            ),
          ];
        },
      },
      component: InputerSubMerchantOutlet,
    },
    {
      path: '/inputer/aggregator/:idAggregator(\\d+)/sub-merchant/:id(\\d+)/register',
      name: 'InputerSubMerchantOutletRegister',
      meta: {
        title: 'BNI QRIS - Sub Merchant Outlet',
        appBarTitle: 'Sub Merchant Outlet',
        breadcrumbs: (params) => {
          const { id } = params;
          const { idAggregator } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb(
              `${idAggregator}`,
              `/inputer/aggregator/${idAggregator}`,
              true
            ),
            setBreadcrumb(
              'sub merchant',
              `/inputer/aggregator/${idAggregator}/sub-merchant`
            ),
            setBreadcrumb(
              `${id}`,
              `/inputer/aggregator/${idAggregator}/sub-merchant/${id}`,
              true
            ),
            setBreadcrumb(
              'register outlet',
              `/inputer/aggregator/${idAggregator}/sub-merchant/${id}/register`,
              true
            ),
          ];
        },
      },
      component: Register,
    },
    {
      path: '/inputer/aggregator/:idAggregator(\\d+)/sub-merchant/:id/bulk-upload',
      name: 'InputerSubMerchantUpload',
      meta: {
        title: 'BNI QRIS - Sub Merchant Upload',
        appBarTitle: 'Sub Merchant Upload',
        breadcrumbs: (params) => {
          const { id } = params;
          const { idAggregator } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('aggregator', '/inputer/aggregator'),
            setBreadcrumb(
              `${idAggregator}`,
              `/inputer/aggregator/${idAggregator}`,
              true
            ),
            setBreadcrumb(
              'sub merchant',
              `/inputer/aggregator/${idAggregator}/sub-merchant`
            ),
            setBreadcrumb(
              `${id.replaceAll('-', ' ')}`,
              `/inputer/aggregator/${idAggregator}/sub-merchant/${id}`,
              true
            ),
            setBreadcrumb(
              'bulk upload',
              `/inputer/aggregator/${idAggregator}/sub-merchant/${id}/bulk-upload`,
              true
            ),
          ];
        },
      },
      component: InputerAggregatorUpload,
    },
    {
      path: '/inputer/aggregator/:idAggregator(\\d+)/sub-merchant/:idSubMerchant(\\d+)/list-outlet/:id/bulk-upload',
      name: 'InputerSubMerchantOutletUpload',
      meta: {
        title: 'BNI QRIS - Sub Merchant Outlet Upload',
        appBarTitle: 'Sub Merchant Outlet Upload',
      },
      component: InputerAggregatorUpload,
    },
    {
      path: '/inputer/merchant/:id(\\d+)/list-outlet',
      name: 'InputerListOutletMerchant',
      meta: {
        title: 'BNI QRIS - List Outlet Merchant',
        appBarTitle: 'List Outlet Merchant',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('merchant', '/inputer/merchant'),
            setBreadcrumb(`${id}`, `/inputer/merchant/${id}`, true),
            setBreadcrumb(
              'list outlet',
              `/inputer/merchant/${id}/list-outlet`,
              true
            ),
          ];
        },
      },
      component: InputerMerchantOutlet,
    },
    {
      path: '/inputer/merchant/:idMerchant(\\d+)/list-outlet/:id/bulk-upload',
      name: 'InputerBulkUploadOutletMerchant',
      meta: {
        title: 'BNI QRIS - Bulk Upload Outlet Merchant',
        appBarTitle: 'Bulk Upload Outlet Merchant',
        breadcrumbs: (params) => {
          const { id } = params;
          const { idMerchant } = params;
          return [
            setBreadcrumb('inputer', '/inputer', true),
            setBreadcrumb('merchant', '/inputer/merchant'),
            setBreadcrumb(
              `${idMerchant}`,
              `/inputer/merchant/${idMerchant}`,
              true
            ),
            setBreadcrumb(
              'list outlet',
              `/inputer/merchant/${idMerchant}/list-outlet`
            ),
            setBreadcrumb(
              `${id.replaceAll('-', ' ')}`,
              `/inputer/merchant/${idMerchant}/list-outlet/${id}`,
              true
            ),
            setBreadcrumb(
              'bulk upload',
              `/inputer/merchant/${idMerchant}/list-outlet/${id}/bulk-upload`,
              true
            ),
          ];
        },
      },
      component: InputerMerchantUpload,
    },
  ],
};

export default inputerRoute;
